<div class="container">
	@if (showHeader()) {
		<div class="header">
			<div class="location-header">
				@for (location of (displayedLocations() || []).slice(0, 3); track location.id) {
					<h2 class="selected-location">{{ location.name }},</h2>
				}
				@if (displayedLocations().length > 3) {
					<h2 class="selected-location">
						+ {{ displayedLocations().length - 3 }} {{ 'more' | translate }}
					</h2>
				}
			</div>
			<au-search-input
				class="m-b-sxs p-l-sm p-r-sm"
				placeholder="{{ 'type_building_name' | translate }}"
				(searchTextChanged)="filterBuildingsSearch($event)"
				(click)="$event.stopPropagation()"
				subscriptSizingMode="dynamic"
			/>
			<div class="horizontal-divider"></div>
		</div>
	}
	<div class="locations nice-scroll visible-scroll colored-scroll-track">
		@if (loading()) {
			<div class="dialog-centre">
				<mat-spinner diameter="40" />
			</div>
		} @else if (noSearchResults()) {
			<div class="dialog-centre">
				<mat-icon style="scale: 4" [svgIcon]="'sad-robot'" />
				<p class="dialog-centre-text">{{ 'no_results_found' | translate }}</p>
			</div>
		} @else {
			<div class="locations-tree">
				<mat-expansion-panel class="location-tree-panel" [expanded]="true">
					<mat-expansion-panel-header>
						<mat-panel-title>{{ 'my_buildings' | translate }}</mat-panel-title>
					</mat-expansion-panel-header>
					<locations-tree
						[selectableLocations]="myBuildings()"
						(locationSelectionChanged)="myBuildingsSelections.set($event)"
					/>
				</mat-expansion-panel>
				<mat-expansion-panel
					class="location-tree-panel"
					[expanded]="false || searchText() !== ''"
				>
					<mat-expansion-panel-header>
						<mat-panel-title>{{ 'other_locations' | translate }}</mat-panel-title>
					</mat-expansion-panel-header>
					<locations-tree
						[selectableLocations]="filteredLocationList()"
						(locationSelectionChanged)="otherLocationsSelections.set($event)"
					/>
				</mat-expansion-panel>
			</div>
		}
	</div>
</div>
<div class="footer horizontal-divider"></div>
